import lazy from 'preact-lazy';

import { ButtonInjectionProps } from './ButtonInjection';

const ToBeLazyLoaded = lazy(() => import('./ButtonInjection'), null);

export const ButtonInjectionLazy = (props: ButtonInjectionProps) => {
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  return <ToBeLazyLoaded {...props} />;
};
